import {
  ButtonGroup,
  Container,
  IconButton,
  Stack,
  Text,
  Image,
  Spacer,
} from '@chakra-ui/react'
import * as React from 'react'
import { FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa'
import { DiWebplatform } from 'react-icons/di'
export const Footer = () => (
  <Container
    as='footer'
    role='contentinfo'
    py={{
      base: '12',
      md: '16',
    }}
  >
    <Stack
      spacing={{
        base: '4',
        md: '5',
      }}
    >
      <Stack justify='space-between' direction='row' align='center'>
        <Image
          borderRadius='full'
          boxSize='100px'
          src='https://avatars.githubusercontent.com/u/79316453?v=4'
          alt='Sharma Ketan'
        />
        <Spacer />
        <ButtonGroup variant='ghost'>
          <IconButton
            as='a'
            href='https://linkedin.com/in/sharmaketann'
            aria-label='LinkedIn'
            icon={<FaLinkedin fontSize='1.25rem' />}
          />
          <IconButton
            as='a'
            href='https://github.com/Sharmaketann'
            aria-label='GitHub'
            icon={<FaGithub fontSize='1.25rem' />}
          />
          <IconButton
            as='a'
            href='https://twitter.com/ketansharma957'
            aria-label='Twitter'
            icon={<FaTwitter fontSize='1.25rem' />}
          />
          <IconButton
            as='a'
            href='https://sharmaketann.showwcase.com/'
            aria-label='Showwcase'
            icon={<DiWebplatform fontSize='1.25rem' />}
          />
        </ButtonGroup>
      </Stack>
      <Text fontSize='sm' color='subtle' fontWeight='bold'>
        Made with ❤️ in India
      </Text>
    </Stack>
  </Container>
)
